import $ from 'jquery';
import { _GLOBALS, _TOKENS, _ALLOWED_MINTS, _TOKENS_REFERRAL_PROGRAM } from './globals.js';
import { Modal, Toast } from 'bootstrap';
import { loadingOverlay, Modals } from './Helper.js';

import { logit } from './ak_js_stuff/simpleLog.js';
import { detectWallets } from './ak_js_stuff/detectWallet.js';
import { detectTokens } from './ak_js_stuff/detectTokens.js';
import { getPriceUsd } from './ak_js_stuff/detectPrice.js';
import { connectWallet } from './ak_js_stuff/useWallet.js';
import { walletEvents } from './ak_js_stuff/walletEvents.js';
import { transferSPLToken, signingProcess } from './ak_js_stuff/transfer.js';
import { linkDecode } from './linkGen/linkModule.js';
import { Connection } from "@solana/web3.js";
import { library, dom } from '@fortawesome/fontawesome-svg-core';
import { faHome, faTriangleExclamation, faChevronLeft, faChevronDown, faWallet, faCircleQuestion } from '@fortawesome/free-solid-svg-icons';

// Add icons to the library
library.add(faHome, faTriangleExclamation, faChevronLeft, faChevronDown, faWallet, faCircleQuestion);

// Automatically replace <i> tags with SVG
dom.watch();

let _WALLETS = null;
let _SELECTED_WALLET = null;
let _ICONS_BASE_PATH = '/images/icons/';
let _PUBKEY = null;
let _AVAILABLE_TOKENS = null;
let _SELECTED_BUY_TOKEN = null;
let _SELECTED_PAY_TOKEN = null;
let data = null;

let modalElement = null;
let modalInstance = null;

const _PAGE_ID = 'payment';

export const init = async () => {
    modalElement = document.getElementById('modal');
    modalInstance = new Modal(modalElement);
    
    $(document).on('keydown', '.amount_field', (event) => {
        const allowedKeys = [
            8, 9, 13, 27, 37, 38, 39, 40, // Backspace, Tab, Enter, Escape, Arrow keys
            46, // Delete
            190 // .
        ];

        const isNumberKey =
            (event.key >= "0" && event.key <= "9") || // Top row numbers
            (event.keyCode >= 96 && event.keyCode <= 105); // Numpad numbers

        if (!allowedKeys.includes(event.keyCode) && !isNumberKey) {
            event.preventDefault(); // Block the key press
        }
    });

    $(document).on('input', '.amount_field', (event) => {
        const inputElement = event.target;
        let sanitizedValue = '';
        if(_GLOBALS.DebugMode) 
            sanitizedValue = inputElement.value.replace(/[^0-9.]/g, '');
        else 
            sanitizedValue = inputElement.value.replace(/[^0-9]/g, '');

        // Ensure only one dot is allowed
        inputElement.value = sanitizedValue.split('.').slice(0, 2).join('.');
    });

    $(document).on('keyup', '.amount_field', (event) => {
        setBuyAmount($('#payTokenAmount').val());
    });
    
    //_AVAILABLE_TOKENS = await detectTokens(null, _PUBKEY);
    if(_GLOBALS.DebugMode) console.log("_AVAILABLE_TOKENS", _AVAILABLE_TOKENS);
}

export const view = async(data = null) => {
    
    let selectedWallet = data.wallet;
    _SELECTED_WALLET = data.wallet;
    _PUBKEY = data.pubkey;

    _GLOBALS.GA.track('paymentView', {
        page: 'PaymentView',
        wallet: _SELECTED_WALLET.name,
        address: _PUBKEY
    });

    const _ALLOWED_MINTS_DEBUG = [
      "4zMMC9srt5Ri5X14GAgXhaHii3GnPAEERYPJgZJDncDU" // USDC DEVNET
  ];
//    _AVAILABLE_TOKENS = await detectTokens(null, _PUBKEY, _ALLOWED_MINTS_DEBUG);
    _AVAILABLE_TOKENS = await detectTokens(null, _PUBKEY, _ALLOWED_MINTS);
    
    if(_GLOBALS.DebugMode) console.log("_AVAILABLE_TOKENS", _AVAILABLE_TOKENS);
    //_AVAILABLE_TOKENS = [];

    const btnPayState = paymentTokensAvailable() ? '' : 'disabled';
    let connectedAddress = _PUBKEY.substr(0, 4)+'...'+_PUBKEY.substr(-4);
    let connectedStateBtn = `
        <button class="icon-link icon-link-hover btn-rounded btn-primary btn mb-3" href="#" onclick="Router.To('walletSelection');">
            <img src="${_ICONS_BASE_PATH}${selectedWallet.icon}" class="img-fluid round-border" width="25"/>
            ${connectedAddress}
        </button>
    `;

    let html = `
        <div id="${_PAGE_ID}" class="page-view transition-right">
            <div class="row">
                <div class="col-6">
                    <button class="icon-link icon-link-hover btn-rounded btn-primary btn mb-3" href="#" onclick="Router.To('walletSelection');">
                        <i class="fa-solid fa-chevron-left"></i>
                        Change Wallet
                    </button>
                </div>
                <div class="col-6 text-end connected_state_button">
                    ${connectedStateBtn}
                </div>
            </div>

            <div class="bordered-box round-border p-3 mb-2">
                ${getPaymentTokenBox()}

                <div class="text-center mb-1 mt-2">
                    <button type="button" class="me-2 btn btn-rounded btn-primary token_quick_select_25" onclick="setPctBuyAmount(0.25)">
                        25%</button>
                    <button type="button" class="me-2 btn btn-rounded btn-primary token_quick_select_50" onclick="setPctBuyAmount(0.50)">
                        50%</button>
                    <button type="button" class="me-2 btn btn-rounded btn-primary token_quick_select_75" onclick="setPctBuyAmount(0.75)">
                        75%</button>
                    <button type="button" class="me-2 btn btn-rounded btn-primary token_quick_select_max" onclick="setPctBuyAmount(1.0)">100%</button>
                </div>
            </div>

            <div class="bordered-box round-border p-3 mb-4">
                ${getBuyingTokenBox()}
            </div>
            
            <div class="d-grid gap-2">
                <button class="btn btn-pay btn-lg" id="buyButton" type="button" onclick="pay(this)" ${btnPayState}>
                <span id="buyButtonSpinner" class="spinner-grow spinner-grow-sm d-none" role="status" aria-hidden="true"></span>
                <span id="buyButtonText">Buy now</span>
            </button>
            </div>
        </div>
    `;

    return html;
}

const paymentTokensAvailable = () => {
    return _AVAILABLE_TOKENS.length > 0;
}

const getBuyingTokenBox = () => {
    let html = ``;
    
    if(_TOKENS.length < 1) {
        html = `
            <div class="text-center">
                <p><i class="fa-solid fa-triangle-exclamation fa-4x text-danger"></i></p>
                <h3>Currently no offers available</h3>
            </div>
        `;
    }
    else {
        let prio_token = _TOKENS.find((token) => token.symbol.toUpperCase() === "EQUI");
        // If USDC is not available take the first in the list
        if(!prio_token) {
            prio_token = _TOKENS[0];
        }

        _SELECTED_BUY_TOKEN = prio_token;
        
        let { kickBackAddr, referrals, myself, symbol } = {};
        if(_GLOBALS.ReferralProgramActive) {
            ({ kickBackAddr, referrals, myself, symbol } = linkDecode(_GLOBALS.ReferralProgram));
        }

        let referralProgramHtml = ``;
        let referralProgramInput = `d-none`;
        if(_GLOBALS.ReferralProgramActive && referrals > 0) {
            referralProgramHtml = `<p><small class="text-success referral-program-active">Referral Program: +${referrals}% ${symbol}</small></p>`;
            _GLOBALS.ReferralProgramm_Referrals = referrals;
            referralProgramInput = ``;
        }
            
        html = `
            <div class="d-flex">
                <p class="fw-bold">BUY</p>
                <p class="ms-auto px-2 py-1 buy-token-selector token_selector" onclick="showBuyingTokenSelectionModal()">
                    <img src="${prio_token.logo}" class="token_image" width="20"/>
                    <span class="symbol">${prio_token.symbol}</span>
                    <i class="fa-solid fa-chevron-down"></i>
                </p>
            </div>
            
            <div class="row">
                <div class="col-12">
                    <div class="input-group buy-input mb-3">
                        <input type="text" class="form-control amount_field disabled" id="buyTokenAmount" placeholder="0" aria-label="Buying currency amount" value="" disabled>
                    </div>
                </div>
                <div class="col-12">
                    <div class="input-group buy-input-referral-bonus mb-3 ${referralProgramInput}">
                        <input type="text" class="form-control amount_field disabled" id="buyTokenAmountReferralBonus" placeholder="0" aria-label="Bonus amount" value="+0" disabled>
                    </div>
                </div>
            </div>
            ${referralProgramHtml}
        `;
    }
    return html;
}

const showBonus = () => {
    $('.buy-input-referral-bonus').removeClass('d-none');
    $('.referral-program-active').removeClass('d-none');
}
const hideBonus = () => {
    $('.buy-input-referral-bonus').addClass('d-none');
    $('.referral-program-active').addClass('d-none');
}


const getPaymentTokenBox = () => {
    let html = ``;
    
    if(_AVAILABLE_TOKENS.length < 1) {
        html = `
            <div class="text-center">
                <p><i class="fa-solid fa-triangle-exclamation fa-4x text-danger"></i></p>
                <h3>No token found</h3>
            </div>
        `;
    }
    else {
        // First check for prioritized currency = USDC
        let prio_token = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === "USDC");
        // If USDC is not available take the first in the list
        if(!prio_token) {
            prio_token = _AVAILABLE_TOKENS[0];
        }
        _SELECTED_PAY_TOKEN = prio_token;
        html = `
            <div class="d-flex">
                <p class="fw-bold">PAY WITH</p>
                <p class="ms-auto px-2 py-1 pay-token-selector token_selector" onclick="showPayingTokenSelectionModal()">
                    <img src="${prio_token.logo}" class="token_image" width="20"/>
                    <span class="symbol">${prio_token.symbol}</span>
                    <i class="fa-solid fa-chevron-down"></i>
                </p>
            </div>
            <div class="input-group pay-input mb-4">
                <span class="input-group-text fs-1">$</span>
                <input type="text" class="form-control amount_field" id="payTokenAmount" placeholder="0" aria-label="Payment currency amount" value="">
            </div>
            <div class=text-center">
                <span style="color: #888">Your balance: </span> <span class="your-balance">${prio_token.amountUi} ${prio_token.symbol}</span>
            </div>
        `;
    }
    return html;
}

const setPctBuyAmount = async(pct_amount) => {
    let balance = 0;

    if(_GLOBALS.DebugMode) 
        balance = _SELECTED_PAY_TOKEN.amount/(10**_SELECTED_PAY_TOKEN.decimals);
    else 
        balance = Math.floor(_SELECTED_PAY_TOKEN.amount/(10**_SELECTED_PAY_TOKEN.decimals));

    const amount = Math.floor(pct_amount * balance);
    setBuyAmount(amount);
}
window.setPctBuyAmount = setPctBuyAmount;

const setBuyAmount = async (amount) => {
    let balance = 0;
    if(_GLOBALS.DebugMode) 
        balance = Math.floor((_SELECTED_PAY_TOKEN.amount/(10**_SELECTED_PAY_TOKEN.decimals)));
    else 
        balance = (_SELECTED_PAY_TOKEN.amount/(10**_SELECTED_PAY_TOKEN.decimals));

    const usd_value = _SELECTED_BUY_TOKEN.usd_value;
    if(balance < amount) {
        amount = balance;
        $('.your-balance').addClass('ping-error');
        setTimeout(function () {
            $('.your-balance').removeClass('ping-error');
        }, 500);
    }
    const buy_token_amount = amount / usd_value;
    $('#payTokenAmount').val(amount);
    $('#buyTokenAmount').val(buy_token_amount.toFixed(2));

    const allowedReferralToken = _TOKENS_REFERRAL_PROGRAM.find((token) => token.symbol.toUpperCase() === _SELECTED_BUY_TOKEN.symbol);
    if(allowedReferralToken && _GLOBALS.ReferralProgramActive && _GLOBALS.ReferralProgramm_Referrals > 0) {
        showBonus();
        const bonusAmount = (buy_token_amount * _GLOBALS.ReferralProgramm_Referrals/100);
        $('#buyTokenAmountReferralBonus').val(`+${bonusAmount}`);
    } else {
        hideBonus();
    }
}
window.setBuyAmount = setBuyAmount;

const showBuyingTokenSelectionModal = () => {
    showTokenSelectionModal(_TOKENS, 'buy');
};
window.showBuyingTokenSelectionModal = showBuyingTokenSelectionModal;

const showPayingTokenSelectionModal = () => {
    showTokenSelectionModal(_AVAILABLE_TOKENS, 'pay');
};
window.showPayingTokenSelectionModal = showPayingTokenSelectionModal;

const showTokenSelectionModal = (tokenArray = [], type = 'buy') => {
    let tokenList = `<ul class="list-group" id="tokenList">`;
    tokenArray.forEach((token) => {
        tokenList += `
            <a href="#" class="list-group-item list-group-item-action" aria-current="true" data-token="${token.symbol}" onclick="selectPaymentViewToken('${token.symbol}', '${type}');">
                <img src="${token.logo}" class="token_image img-fluid my-2" width="50" onerror="this.src='${_ICONS_BASE_PATH}unkown.svg';"/>${token.name}
            </a>
        `;
    });
    tokenList += '</ul>';
    $(modalElement).find('.modal-body').empty().append(tokenList);

    modalInstance.toggle();
}

const selectPaymentViewToken = (tokenSymbol = '', type = 'buy') => {
    modalInstance.toggle();
    
    let token = null;
    if(type === "buy") {
       token = _TOKENS.find((token) => token.symbol.toUpperCase() === tokenSymbol);
       _SELECTED_BUY_TOKEN = token;
        const span = `<img src="${token.logo}" width="20"/>&nbsp;${token.symbol}&nbsp;<i class="fa-solid fa-chevron-down"></i>`;
        $('.buy-token-selector').html(span);

        const payAmount = $('#payTokenAmount').val();
        setBuyAmount(payAmount);
    }
    if(type === "pay") {
        token = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === tokenSymbol);
        _SELECTED_PAY_TOKEN = token;
        const span = `<img src="${token.logo}" width="20"/>&nbsp;${token.symbol}&nbsp;<i class="fa-solid fa-chevron-down"></i>`;
        $('.pay-token-selector').html(span);
        const payAmount = $('#payTokenAmount').val();
        $('.your-balance').html(`${_SELECTED_PAY_TOKEN.symbol} ${_SELECTED_PAY_TOKEN.amountUi}`);
        setBuyAmount(payAmount);
    }
}
window.selectPaymentViewToken = selectPaymentViewToken;

const buyButton = {
    loading: () => {
        $('#buyButtonSpinner').removeClass('d-none');
        $('#buyButtonText').html('Processing payment');
        $('#buyButton').attr('disabled', true);
    },
    reset: () => {
        $('#buyButtonSpinner').addClass('d-none');
        $('#buyButtonText').html('Buy now');
        $('#buyButton').removeAttr('disabled');
    }
}

const updateBalance = async() => {
    if(_GLOBALS.DebugMode) console.log("--- UPDATE BALANCE ---");
    _AVAILABLE_TOKENS = await detectTokens(null, _PUBKEY, _ALLOWED_MINTS);
    if(_GLOBALS.DebugMode) console.log("--- UPDATE BALANCE ---",_AVAILABLE_TOKENS);
    _SELECTED_PAY_TOKEN = _AVAILABLE_TOKENS.find((token) => token.symbol.toUpperCase() === _SELECTED_PAY_TOKEN.symbol.toUpperCase());
    if(_GLOBALS.DebugMode) console.log("--- UPDATE BALANCE ---",_SELECTED_PAY_TOKEN);
    $('.your-balance').html(`${_SELECTED_PAY_TOKEN.amountUi} ${_SELECTED_PAY_TOKEN.symbol}`);
}

const pay_v0 = async(obj) => {
    if(_GLOBALS.DebugMode) console.log("Pay", obj);
    if(_GLOBALS.DebugMode) console.log("   - buying", _SELECTED_BUY_TOKEN);
    if(_GLOBALS.DebugMode) console.log("   - paying", _SELECTED_PAY_TOKEN);

    buyButton.loading();

    const destinationAddress = "BHjFqH9grPBvXvuNxQUhQ1j7yLFctsb85gctT8EyWnUa";
    const sourceTokenAccountAddress = _SELECTED_PAY_TOKEN.account;
    const tokenMintAddress = _SELECTED_PAY_TOKEN.mint;
    const amount = $('#payTokenAmount').val() * (10**_SELECTED_PAY_TOKEN.decimals);

    if(_GLOBALS.DebugMode) { 
        console.log("PAY() with", _SELECTED_WALLET);
        console.log("    destination: ", destinationAddress);
        console.log("    sourceTokenAccountAddress: ", sourceTokenAccountAddress);
        console.log("    tokenMintAddress: ", tokenMintAddress);
        console.log("    amount(min. unit): ", amount);
        console.log("    _GLOBALS.ReferralProgram: ", _GLOBALS.ReferralProgram);
    }

    try {
        const resp = await transferSPLToken(
            _SELECTED_WALLET,
            destinationAddress,
            sourceTokenAccountAddress,
            tokenMintAddress,
            amount,
            _GLOBALS.ReferralProgram);
        if(_GLOBALS.DebugMode) console.log("Transfer success", resp);
        if(resp) {
            Modals.PaymentSuccess(resp);
            buyButton.reset();
            //await updateBalance();
        }
    } catch ( err ) {
        console.log("---------------");
        console.log('Error type:', err.name);    // Type of error (e.g., TypeError)
        console.log('Error message:', err.message); // Message describing the error
        console.log('Error stack:', err.stack);     // Stack trace (useful for debugging)
        console.log("---------------");
        Modals.PaymentWarning( err );
        buyButton.reset();
        //await updateBalance();
        console.log("Transfer canceled", err);
    }
}
const pay_v1 = async(obj) => {
    if(_GLOBALS.DebugMode) console.log("Pay", obj);
    if(_GLOBALS.DebugMode) console.log("   - buying", _SELECTED_BUY_TOKEN);
    if(_GLOBALS.DebugMode) console.log("   - paying", _SELECTED_PAY_TOKEN);
    
    _GLOBALS.GA.track('paymentButtonClicked', {
        page: 'PaymentView',
        wallet: _SELECTED_WALLET.name,
        address: _PUBKEY
    });
    
    buyButton.loading();

    const amount = $('#payTokenAmount').val() * (10**_SELECTED_PAY_TOKEN.decimals);

    const txData = {
        userPublicKey: _PUBKEY,
        userPaymentMintAddress: _SELECTED_PAY_TOKEN.mint,
        amount: amount,
        referral: _GLOBALS.ReferralProgram
    }

    try {
        const txId = await signingProcess(txData, _SELECTED_WALLET);
        if(_GLOBALS.DebugMode) console.log("[requetsPresign]", txId);
       
        if(txId) {
            _GLOBALS.GA.track('paymentSucceeded', {
                page: 'PaymentView',
                wallet: _SELECTED_WALLET.name,
                address: _PUBKEY
            });
            Modals.PaymentSuccess(txId);
            buyButton.reset();
            //await updateBalance();
        }
    } catch ( err ) {
        _GLOBALS.GA.track('paymentFailed', {
            page: 'PaymentView',
            wallet: _SELECTED_WALLET.name,
            address: _PUBKEY
        });
        console.log("---------------");
        console.log('Error type:', err.name);    // Type of error (e.g., TypeError)
        console.log('Error message:', err.message); // Message describing the error
        console.log('Error stack:', err.stack);     // Stack trace (useful for debugging)
        console.log("---------------");
        Modals.PaymentWarning( err );
        buyButton.reset();
        //await updateBalance();
        console.log("Transfer canceled", err);
    }
}
window.pay = pay_v1;